<template>
  <div>
    <div class="address-block_header">
      <BaseSkeleton class="w-[60px] h-[20px] rounded-md" />
    </div>
    <div class="address-block">
      <div class="address-block_wrapper">
        <div class="address-block_left">
          <BaseSkeleton class="w-[40px] h-[14px] rounded-md mb-[8px]" />
          <div class="address-block_address_row">
            <BaseSkeleton class="w-[200px] h-[16px] rounded-md" />
            <BaseSkeleton class="w-[16px] h-[16px] rounded-md" />
          </div>
        </div>
        <div class="address-block_right">
          <BaseSkeleton class="w-[30px] h-[14px] rounded-md mb-[8px]" />
          <div class="address-block_address_row">
            <BaseSkeleton class="w-[200px] h-[16px] rounded-md" />
            <BaseSkeleton class="w-[16px] h-[16px] rounded-md" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import BaseSkeleton from "@/shared/ui/BaseSkeleton/BaseSkeleton.vue";
</script>

<style lang="scss" scoped>
.address-block {
  display: flex;
  flex-direction: column;
  border-radius: 10px;
  border: 1px solid var(--Dark-850, #1a1a1a);
  padding: 20px 24px;

  &_address_row:has(+ .address-block_amount_row:not(:last-child)) {
    margin-bottom: 15px;
  }

  &_address_row:not(:has(+ .address-block_amount_row)) {
    margin-bottom: 0;
  }

  &_header {
    margin-bottom: 16px;
  }

  &_divider {
    margin-bottom: 16px;
    border-bottom: 1px solid var(--Dark-850, #1a1a1a);
  }

  &_address {
    width: 100%;
    overflow: hidden;
    color: #fff;
    text-overflow: ellipsis;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 130%;

    @media (max-width: 1024px) {
      max-width: 220px;
    }

    @media (max-width: 768px) {
      max-width: 100%;
    }

    &_row {
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 8px;
    }
  }

  &_wrapper {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  &_amount_main {
    margin-top: 16px;
  }

  &_amount {
    font-size: 14px;
    font-weight: 500;
    line-height: 1.4;
    color: #fafafa;
    display: flex;
    align-items: center;
    gap: 4px;

    &.neutral {
      color: #fafafa;
    }

    &_row {
      display: flex;
      align-items: center;
      justify-content: space-between;
    }

    &_title {
      line-height: 150%;
    }

    &_icon {
      width: 16px;
      height: 16px;
    }
  }

  &_copy {
    flex-shrink: 0;
    width: 16px;
    height: 16px;
    transition: color 0.3s;
    cursor: pointer;
    filter: brightness(0) saturate(100%) invert(76%) sepia(48%) saturate(5896%)
      hue-rotate(220deg) brightness(104%) contrast(98%);

    &:hover {
      filter: brightness(0) saturate(100%) invert(31%) sepia(96%)
        saturate(3271%) hue-rotate(251deg) brightness(100%) contrast(103%);
    }
  }
}
</style>
